<template>
  <list-item
    :card="item"
    :fields="['listingType', 'price']"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #image>
      <card-image :image-url="item.image" />
    </template>

    <template #info>
      <div class="item-info">
        <div class="platform-text">{{ item.platform }}</div>
        <div class="item-text">{{ item.title }}</div>

        <align class="extra-info">
          <countdown-timer
            v-if="item.endDate && item.listingType === 'Auction'"
            :end-time="item.endDate"
          />

          <span v-if="typeof item.bids === 'number'">Bids: {{ item.bids }}</span>
          <span v-if="typeof item.watchers === 'number'">Watchers: {{ item.watchers }}</span>
        </align>
      </div>
    </template>
  </list-item>
</template>

<script>
import Align from './Align';
import CardImage from './CardImage';
import CountdownTimer from './CountdownTimer';
import ListItem from './ListItem';

export default {
  components: {
    Align,
    CardImage,
    CountdownTimer,
    ListItem,
  },

  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.item-info {
  flex: 1;
}

.platform-text {
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.5;
  letter-spacing: 1px;
}

.item-text {
  font-weight: bold;
  font-size: 18px;
}

.extra-info {
  margin-top: $gp * .25;

  span {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
